<ion-header>
  <ion-toolbar>


    <ion-buttons slot="start">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title style="margin-top: 0.2em; display: inline-block">Scan Product</ion-title>

  </ion-toolbar>
</ion-header>

<ion-content *ngIf="screenPreferences">

  <ion-grid>
    <ion-row>
      <ion-col size="5">
        <ion-select [(ngModel)]="screenPreferences.selectedBarcodeDevice"
                    (ngModelChange)="saveConfig();" interface="popover"
                    [compareWith]="mediaDeviceCompare">

          <ion-select-option *ngFor="let device of barcodeMediaDevices"
                             [value]="device">{{device.label}}</ion-select-option>
        </ion-select>
      </ion-col>
      <ion-col size="1">
        <ion-button size="small" (click)="openBarcodeFormat()">
          <ion-icon name="barcode"></ion-icon>
        </ion-button>
      </ion-col>
      <ion-col size="3">
        <ion-select #barcodeFormatSelect hidden multiple [compareWith]="barcodeFormatCompare"
                    [(ngModel)]="screenPreferences.selectedScannerFormats" (ionChange)="saveConfig()">
          <ion-select-option class="ion-text-wrap" *ngFor="let allFormat of allowedFormats"
                             [value]="allFormat">
            {{ allFormat.shortDescription }}
          </ion-select-option>
        </ion-select>
      </ion-col>
      <ion-col size="3">
        <ion-button size="small" #torchbutton (tap)="handleClickingTorch(); ">
          <ion-icon size="small" slot="icon-only" name="flashlight" style="display: inline-block"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>

  <zxing-scanner #scanner
                 (camerasFound)="onCamerasFound($event)"
                 [torch]="torchEnabled"
                 (torchCompatible)="onTorchCompatible($event)"
                 [formats]="allowedFormats"
                 [device]="selectedDevice"
                 [enable]="enabled"
                 (scanSuccess)="handleScanResult($event)"
                 (permissionResponse)="onHasPermission($event)">
  </zxing-scanner>
</ion-content>
